import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { type Banner } from '../types';
import { bannerApi } from '../api';
import { bannerKeys } from './banner.keys';

export function useBanner(
  id?: string,
  options?: Omit<UseQueryOptions<Banner, Error>, 'queryKey' | 'queryFn'>
) {
  const query = useQuery({
    queryKey: bannerKeys.detail(id ?? ''),
    queryFn: ({ signal }) => bannerApi.get(id!, signal),
    enabled: Boolean(id),
    ...(options as Omit<UseQueryOptions<Banner, Error>, 'queryKey' | 'queryFn'>),
  });

  return {
    banner: query.data,
    isLoading: query.isLoading,
    error: query.error,
    queryResult: query,
  };
}
